import { render, staticRenderFns } from "./FirstDeposit.vue?vue&type=template&id=38f9f9b6&"
import script from "./FirstDeposit.vue?vue&type=script&lang=js&"
export * from "./FirstDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports